import { useAnalytics } from '../hooks/useAnalytics';
export function AnalyticsProvider({ trackingId, debug = false, children }) {
    useAnalytics(trackingId, debug);
    return children;
  }
  